import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var ReportFlagIcon = function ReportFlagIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.407 2c1.079 0 2.112.223 2.986.633l.113.054c.112.056.221.114.328.176l.105.063.302.186.072.035c1.58.74 3.916.69 5.394-.148l.092-.053a.783.783 0 011.093.303.86.86 0 01.097.554c.004.03.008.06.01.092v8.938a.857.857 0 01-.32.668.796.796 0 01-.07.049l-.008.004a.716.716 0 01-.038.022l.038-.022c-1.915 1.156-4.84 1.252-6.923.29l-.131-.053-.009-.006-.141-.082-.052-.027-.107-.06-.106-.062-.361-.218-.022-.011c-.63-.298-1.397-.474-2.213-.49l-.129-.002c-2.124 0-3.756 1.06-3.806 2.17l-.001.053v6.11c0 .46-.358.834-.8.834-.426 0-.774-.347-.799-.784L4 21.166V2.834c0-.46.358-.833.8-.833.426 0 .774.347.799.784l.001.05v.271C6.584 2.412 7.938 2 9.406 2zm0 1.667c-2.124 0-3.756 1.06-3.806 2.17l-.001.052v6.383c.985-.693 2.339-1.105 3.807-1.105 1.079 0 2.112.222 2.986.632l.113.055c.112.055.221.114.328.176l.105.063.302.186.072.035c1.474.69 3.607.693 5.088.009V4.936c-1.806.605-4.04.519-5.723-.26l-.131-.052-.009-.006-.141-.081-.052-.027-.107-.06-.106-.062-.361-.22-.022-.01c-.63-.298-1.397-.473-2.213-.49l-.129-.001z"
  }));
};

ReportFlagIcon.displayName = 'ReportFlagIcon';
export default ReportFlagIcon;